import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { t } from '../hooks/useT';

const HIDE_FOOTER = new Set(['/play', '/practice', '/arena']);

function hideFooter(pathname: string) {
  if (HIDE_FOOTER.has(pathname)) return true;
  if (/^\/archives\/[^/]+\/play$/.test(pathname)) return true;
  if (/^\/leagues\/[^/]+\/play\//.test(pathname)) return true;
  return false;
}

export function SiteFooter() {
  const { pathname } = useLocation();

  if (hideFooter(pathname)) return null;

  return (
    <footer className="site-footer">
      <nav className="site-footer-nav" aria-label={t('legal.footer')}>
        <Link to="/mentions-legales">{t('legal.mentions')}</Link>
        <Link to="/cgu">{t('legal.cgu')}</Link>
        <Link to="/cgv">{t('legal.cgv')}</Link>
        <Link to="/confidentialite">{t('legal.privacy')}</Link>
        <Link to="/credits">{t('gallery.credits')}</Link>
      </nav>
      <p className="site-footer-copy">
        Dezoom — édité par{' '}
        <a href="https://progragames.com/" target="_blank" rel="noopener noreferrer">
          PrograGames
        </a>
      </p>
    </footer>
  );
}
